import { useCallback } from "react";
import { useLocalStorage } from "react-migration/lib/persistence/state/useLocalStorage";

export function usePersistentToggleState(
  persistenceKey: string,
  defaultExpanded = false
): [(id: string) => boolean, (id: string, value: boolean) => void] {
  const [toggledItems, setToggledItems] = useLocalStorage<string[]>(persistenceKey, []);

  const setState = useCallback(
    (id: string, collapsed: boolean) => {
      setToggledItems((currentState) => [
        ...currentState.filter((i) => i !== id),
        ...(collapsed === defaultExpanded ? [id] : []),
      ]);
    },
    [setToggledItems, defaultExpanded]
  );

  const getState = useCallback(
    (id: string) => {
      // This defines what a toggled item means. If everything is expanded by default, then a toggled item means collapsed,
      // and vice versa. This logic is applied here - return true if the item is expanded, false if it is not.
      return defaultExpanded ? toggledItems.includes(id) : !toggledItems.includes(id);
    },
    [toggledItems, defaultExpanded]
  );
  return [getState, setState];
}
